import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-169fcdcd")

_pushScopeId("data-v-169fcdcd")
const _hoisted_1 = { class: "justify-between" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ['p-5 flex flex-wrap ' + _ctx.centerCard ? 'items-center justify-center' + ' ' + _ctx.displayGrid: '']
  }, [
    _createVNode("div", {
      class: ['flex-shrink-0 relative rounded-3xl shadow-xl ' + _ctx.cardWidth + ' ' + _ctx.cardHeight + ' ' + _ctx.cardBg + ' ' + _ctx.mobileCardWidth + ' ' + _ctx.overflowCard + ' ' + _ctx.cardInnerMargin]
    }, [
      _createVNode("div", {
        class: ['relative text-white' + ' ' + _ctx.cardPadding] + ' ' + _ctx.cardMargin
      }, [
        _createVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2)
    ], 2)
  ], 2))
})